import { render } from "./ViewExhibit.vue?vue&type=template&id=48c2a7ba&scoped=true"
import script from "./ViewExhibit.vue?vue&type=script&lang=js"
export * from "./ViewExhibit.vue?vue&type=script&lang=js"

import "./ViewExhibit.vue?vue&type=style&index=0&id=48c2a7ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c2a7ba"]])

export default __exports__